import { put, cancelled } from 'redux-saga/effects';
import { noop } from 'lodash';

import config from 'config';
import { authApi } from 'config/antonio';
import * as log from 'config/loglevel';
import { takeRequest } from 'services/sagas/takeRequest';
import { createUIErrorMessage } from 'modules/errors';
import { fetchUsers as actions, fetchUsersTypes } from '../actions';
import { Users } from '../../types';

function* fetchUsersHandler() {
    const controller = new AbortController();
    try {
        const { data } = yield* authApi.get<Users>(config.api.users);
        yield put(actions.fetchUsersSuccess(data));

    } catch (error) {
        log.error(error);
        const uiError = createUIErrorMessage(error);
        yield put(actions.fetchUsersFailure(uiError));
    } finally {
        if (yield cancelled()) {
            controller.abort();
        }
    }
}

export default function* () {
    yield takeRequest(
        {
            requestIdSelector: () => 'fetchUsersRequest',
            leading: true,
        },
        {
            pattern: fetchUsersTypes.FETCH_USERS_REQUEST,
            handler: fetchUsersHandler,
        },
        {
            pattern: fetchUsersTypes.FETCH_USERS_CANCEL,
            handler: noop,
        },
    );
}
